import React from 'react'
import { Fragment } from 'react'

const FormContact = () => {
    return (
        <Fragment>
            <h3 className="normal font__size--40 text__40-1024 text__40-md text__40-mm">Our Contact Details</h3>
            <p className='normal font__size--14 text__14-1024 color__gray-1 mb-4'>We'd love to hear from you! Please fill out the form below and we'll get back to you as soon as possible.</p>

            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="" className='medium font__size--16 text__16-1024'>First Name</label>
                        <input type="text" className='form-control medium font__size--16 text__16-1024 color__gray-1 wrapper__field-input' placeholder='First Name' />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="" className='medium font__size--16 text__16-1024'>Last Name</label>
                        <input type="text" className='form-control medium font__size--16 text__16-1024 color__gray-1 wrapper__field-input' placeholder='Last Name' />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="" className='medium font__size--16 text__16-1024'>Email Address*</label>
                        <input type="text" className='form-control medium font__size--16 text__16-1024 color__gray-1 wrapper__field-input' placeholder='Email' />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group">
                        <label htmlFor="" className='medium font__size--16 text__16-1024'>Service</label>
                        <select name="" className='form-control medium font__size--16 text__16-1024 color__gray-1 wrapper__field-input' id="">
                            <option value="" hidden selected disabled >Select Service</option>
                            <option value="" >Service</option>
                            <option value="" >Service</option>
                        </select>

                    </div>
                </div>
            </div>

            <div className="form-group">
                <label htmlFor="" className='medium font__size--16 text__16-1024'>Comments / Questions</label>
                <textarea cols="30" rows="10" type="text" className='form-control medium font__size--16 text__16-1024 color__gray-1 wrapper__field-input texarea' placeholder='Comments / Questions' />
            </div>

            <div className="text-center text-md-left">
                <a href="#!" className="medium font__size--16 text__16-1024 btn btn__orange color__white shadow rounded__50 pointer">Send Message</a>
            </div>
        </Fragment>
    )
}

export default FormContact